import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";
import { getUserLicenseName } from "../FeaturePackages/misc";
import { SupportInformationViewModel } from "client/Api/Support/support";
import { Space } from "client/Components";
import styles from "./SupportInformation.module.less";

export type SupportInformationProps = {
	model: SupportInformationViewModel;
};

export const SupportInformation = (props: SupportInformationProps): ReactElement => {
	const {
		model
	} = props;

	const {
		productVersion,
		requestInformation,
		device,
		operatingSystem,
		browser,
		userAgent,
		userLicense,
	} = model;

	return (
		<div>
			<p className={styles.entry}>
				<span className={styles.label}>
					Scheme:
				</span>
				<Space />
				{requestInformation.scheme}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					Host:
				</span>
				<Space />
				{requestInformation.host}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					Port:
				</span>
				<Space />
				{requestInformation.port}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					Client ip:
				</span>
				<Space />
				{requestInformation.clientIp}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					Device:
				</span>
				<Space />
				{device}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					Operating system:
				</span>
				<Space />
				{operatingSystem}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					Browser:
				</span>
				<Space />
				{browser}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					User agent:
				</span>
				<Space />
				{userAgent}
			</p>
			<p className={styles.entry}>
				<span className={styles.label}>
					{localize("_CurrentVersion")}:
				</span>
				<Space />
				{productVersion}
			</p>
			{userLicense && (
				<p className={styles.entry}>
					<span className={styles.label}>
						{localize("_Subscription")}:
					</span>
					<Space />
					{getUserLicenseName(userLicense)}
				</p>
			)}
		</div>
	);
};
SupportInformation.displayName = "SupportInformation";
